<template>
  <div id="collectReceipt">
    <div class="setting-box" v-show="!isCollectReceiptEdit">
      <div class="title">
        收款
        <div class="button" @click="toEdit('collectReceipt')">管理</div>
      </div>
      <div class="tip">
        <el-row class="margin-bottom">
          <el-col :span="3" class="tip-tit">POS手续费计算</el-col>
          <el-col :span="4"
            >收款金额 {{ collectReceipt.chargesRateOfPos | numNull }} %，封顶
            {{ collectReceipt.cappingAmountOfPos | numNull }} 元
          </el-col>
          <el-col :span="15"
            >当收款方式为pos机时，系统自动计算手续费，财务审批到账时可修改
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="3">收据打印模板</el-col>
          <el-col :span="20"
            >所有打印内容在收据上的显示位置需要按照<span
              class="click-btn"
              @click="showPic"
              >示意图（点击查看）</span
            >进行测量并填写，若不想展示某一项内容，则坐标可填（99,99）
          </el-col>
        </el-row> -->
      </div>
      <!-- <div class="setting-val">
        <el-table :data="collectReceiptOne" border>
          <el-table-column
            prop="name"
            label="打印内容"
            min-width="150"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="xCoordinate"
            label="横坐标"
            min-width="150"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="yCoordinate"
            label="纵坐标"
            min-width="150"
            :resizable="false"
          >
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="../../../../assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div
              class="empty-box"
              v-if="!isLoading && !collectReceiptOne.length"
            >
              列表为空
            </div>
          </template>
        </el-table>
        <el-table :data="collectReceiptTwo" border>
          <el-table-column
            prop="name"
            label="打印内容"
            min-width="150"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="xCoordinate"
            label="横坐标"
            min-width="150"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="yCoordinate"
            label="纵坐标"
            min-width="150"
            :resizable="false"
          >
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="../../../../assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div
              class="empty-box"
              v-if="!isLoading && !collectReceiptTwo.length"
            >
              列表为空
            </div>
          </template>
        </el-table>
      </div> -->
    </div>
    <div class="setting-box" v-show="isCollectReceiptEdit">
      <div class="title">
        收款
        <div class="button">
          <el-button type="primary" @click="updateCollectReceipt"
            >确定</el-button
          >
          <el-button @click="getSettingData()">取消</el-button>
        </div>
      </div>
      <div class="tip">
        <el-row>
          <el-col :span="3" class="tip-tit">POS手续费计算</el-col>
          <el-col :span="10" class="tip-val"
            >收款金额
            <el-input
              class="small-input"
              v-model="collectReceiptForm.chargesRateOfPos"
              placeholder="请输入占比"
            ></el-input>
            %，封顶
            <el-input
              class="small-input"
              v-model="collectReceiptForm.cappingAmountOfPos"
              placeholder="请输入最高额度"
            ></el-input
            >元
          </el-col>
          <el-col :span="10"
            >当收款方式为pos机时，系统自动计算手续费，财务审批到账时可修改
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">收据打印模板</el-col>
          <el-col :span="20"
            >所有打印内容在收据上的显示位置需要按照<span>示意图（点击查看）</span>进行测量并填写，若不想展示某一项内容，则坐标可填（99,99）
          </el-col>
        </el-row>
      </div>
      <!-- <div class="setting-val">
        <el-table :data="collectReceiptOne" border>
          <el-table-column label="打印内容" min-width="150" :resizable="false">
            <template slot-scope="scope">
              {{ collectReceiptOne[scope.$index].name }}
            </template>
          </el-table-column>
          <el-table-column label="横坐标" min-width="150" :resizable="false">
            <template slot-scope="scope">
              <el-input
                class="small-input"
                v-model="collectReceiptOne[scope.$index].xCoordinate"
                placeholder="请输入横坐标"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="纵坐标" min-width="150" :resizable="false">
            <template slot-scope="scope">
              <el-input
                class="small-input"
                v-model="collectReceiptOne[scope.$index].yCoordinate"
                placeholder="请输入纵坐标"
              ></el-input>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="../../../../assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div
              class="empty-box"
              v-if="!isLoading && !collectReceiptOne.length"
            >
              列表为空
            </div>
          </template>
        </el-table>
        <el-table :data="collectReceiptTwo" border>
          <el-table-column label="打印内容" min-width="150" :resizable="false">
            <template slot-scope="scope">
              {{ collectReceiptTwo[scope.$index].name }}
            </template>
          </el-table-column>
          <el-table-column label="横坐标" min-width="150" :resizable="false">
            <template slot-scope="scope">
              <el-input
                class="small-input"
                v-model="collectReceiptTwo[scope.$index].xCoordinate"
                placeholder="请输入横坐标"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="纵坐标" min-width="150" :resizable="false">
            <template slot-scope="scope">
              <el-input
                class="small-input"
                v-model="collectReceiptTwo[scope.$index].yCoordinate"
                placeholder="请输入纵坐标"
              ></el-input>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="../../../../assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div
              class="empty-box"
              v-if="!isLoading && !collectReceiptTwo.length"
            >
              列表为空
            </div>
          </template>
        </el-table>
      </div> -->
    </div>
    <div class="setting-box last">
      <div class="title">
        付款
        <div class="button" @click="toPaymentEdit('add')">新增</div>
      </div>
      <div class="tip paymentTip">
        <el-row>
          <el-col :span="3" class="tip-tit">附件设置</el-col>
          <el-col :span="10"
            >若所需附件选不到，请先至<span
              class="click-btn"
              @click="toTransaction"
              >交易参数设置</span
            >中添加
          </el-col>
        </el-row>
      </div>
      <div class="setting-val">
        <el-table :data="paymentMaterial" border>
          <el-table-column
            prop="payType"
            label="付款性质"
            min-width="150"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="requiredMaterialTypes"
            label="必填附件"
            min-width="150"
            :resizable="false"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.requiredMaterialTypes.length > 0">
                <span
                  v-for="(item, index) in scope.row.requiredMaterialTypes"
                  :key="index"
                >
                  {{ item }}
                  <span
                    v-if="index < scope.row.requiredMaterialTypes.length - 1"
                    >、</span
                  >
                </span>
              </div>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="notRequiredMaterialTypes"
            label="非必填附件"
            min-width="150"
            :resizable="false"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.notRequiredMaterialTypes.length > 0">
                <span
                  v-for="(item, index) in scope.row.notRequiredMaterialTypes"
                  :key="index"
                >
                  {{ item }}
                  <span
                    v-if="index < scope.row.requiredMaterialTypes.length - 1"
                    >、</span
                  >
                </span>
              </div>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            min-width="150"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button
                  @click.native.prevent="toPaymentEdit('update', scope.row)"
                  type="text"
                  >管理</el-button
                >
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="../../../../assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div
              class="empty-box"
              v-if="!isLoading && !collectReceiptOne.length"
            >
              列表为空
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <el-drawer
      :title="`${drawerTitle}付款附件设置`"
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        {{ drawerTitle }}付款附件设置
        <span @click="isDrawerShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <el-form
        label-position="left"
        label-width="6rem"
        :model="paymentMaterialForm"
        :rules="rules"
      >
        <el-form-item label="付款性质" prop="payType" class="pay-type">
          <el-select
            v-model="paymentMaterialForm.payType"
            placeholder="请选择"
            v-if="drawerTitle == '新增'"
          >
            <el-option
              v-for="item in payTypeDic"
              :key="item.option"
              :label="item.option"
              :value="item.option"
            ></el-option>
          </el-select>
          <span v-else>{{ paymentMaterialForm.payType }}</span>
        </el-form-item>
      </el-form>
      <div class="setting-form">
        <el-table
          :data="settingData"
          border
          class="setting-table"
          row-key="index"
        >
          <el-table-column label="项目值" :resizable="false">
            <template slot-scope="scope">
              <el-select v-model="scope.row.name" placeholder="请选择">
                <el-option
                  v-for="item in paymentMaterialDic"
                  :key="item.option"
                  :label="item.option"
                  :value="item.option"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否必填" :resizable="false">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.required"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="135" :resizable="false">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="moveUp(scope.$index)"
                v-if="scope.$index != 0"
                >上移</el-button
              >
              <el-button
                type="text"
                @click="moveDown(scope.$index)"
                v-if="scope.$index != settingData.length - 1"
                >下移</el-button
              >

              <el-popover placement="bottom" trigger="click">
                <el-button
                  @click.native.prevent="deleteSetting(scope.$index)"
                  type="text"
                  class="del-btn"
                  >删除</el-button
                >
                <el-button
                  slot="reference"
                  type="text"
                  class="more-btn"
                  v-if="!scope.row.isDefault"
                  >更多</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-setting" @click="addSetting">
          <i class="el-icon-plus"></i>添加选项值
        </div>
      </div>
      <span class="dialog-footer">
        <div>
          <el-button @click="isDrawerShow = false">取 消</el-button>
          <el-button type="primary" @click.stop="submitEditSetting"
            >确 定</el-button
          >
        </div>
      </span>
    </el-drawer>
    <el-dialog
      title="收据内容位置测量"
      :visible.sync="isShow"
      class="setting-dialog"
    >
      <div class="tips">
        横坐标、纵坐标可精确到0.1cm , 横坐标为收据最左边距离文字左端的距离 ,
        纵坐标为收据最上边距离文字顶端的距离
      </div>
      <img src="@/assets/image/setting-img.png" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getTransactionSettings,
  updateTransactionSettings,
  updateTransactionPaymentMaterialSettings,
} from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
export default {
  data() {
    return {
      collectReceipt: {},
      collectReceiptForm: {},
      collectReceiptOne: [],
      collectReceiptTwo: [],
      paymentMaterial: [],
      payTypeDic: [],
      paymentMaterialDic: [],
      settingName: "",
      isLoading: false,
      isCollectReceiptEdit: false,
      drawerTitle: "新增",
      isDrawerShow: false,
      isLoadingButton: false,
      isShow: false,
      paymentMaterialForm: {
        payType: "",
        requiredMaterialTypes: [],
        notRequiredMaterialTypes: [],
      },
      settingsCustomData: [
        {
          required: false,
          name: "",
        },
      ],
      settingData: [],
      rules: {
        payType: [
          { required: true, message: "请选择付款性质", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getSettingData();
  },
  methods: {
    deleteSetting(index) {
      this.settingData.splice(index, 1);
    },
    showPic() {
      this.isShow = true;
    },
    toTransaction() {
      this.$emit("childName", "参数配置");
    },
    submitEditSetting() {
      // if (this.permissions["System.UserSettings.Update"]) {
      this.isLoadingButton = true;
      this.paymentMaterialForm.requiredMaterialTypes = [];
      this.paymentMaterialForm.notRequiredMaterialTypes = [];
      this.settingData.map((item) => {
        if (item.required) {
          this.paymentMaterialForm.requiredMaterialTypes.push(item.name);
        } else {
          this.paymentMaterialForm.notRequiredMaterialTypes.push(item.name);
        }
      });
      updateTransactionPaymentMaterialSettings(
        this.$store.getters.generateUpdateSettingsParams,
        this.paymentMaterialForm
      )
        .then((res) => {
          if (res && res.code == 10200) {
            this.isDrawerShow = false;
            this.$message.success({
              message: `修改成功`,
              showClose: true,
            });
            this.getSettingData();
          }
          this.isLoadingButton = false;
          //console.log(res, 999888555222);
        })
        .then((err) => {
          this.isLoadingButton = false;
        });
      // } else {
      // this.$message.warning({
      //   message: `您暂无更新设置权限`,
      //   showClose: true,
      // });
      // }
    },
    addSetting() {
      this.settingData.push({
        required: false,
        name: "",
      });
    },
    // 下移
    moveDown(i) {
      this.swapItems(this.settingData, i, i + 1);
    },
    // 自定义参数下移
    customMoveDown(i) {
      this.swapItems(this.settingsCustomData, i, i + 1);
    },
    // 上移
    moveUp(i) {
      this.swapItems(this.settingData, i, i - 1);
    },
    // 自定义参数上移
    customMoveUp(i) {
      this.swapItems(this.settingsCustomData, i, i - 1);
    },
    // 数组内交换位置
    swapItems(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
    },
    toPaymentEdit(val, item) {
      this.paymentMaterialForm.requiredMaterialTypes = [];
      this.paymentMaterialForm.notRequiredMaterialTypes = [];
      this.settingData = [];
      if (val == "add") {
        this.drawerTitle = "新增";
      } else {
        this.drawerTitle = "管理";
        //console.log(item, 987546);
        this.paymentMaterialForm.payType = item.payType;
        this.paymentMaterialForm.requiredMaterialTypes =
          item.requiredMaterialTypes;
        this.paymentMaterialForm.notRequiredMaterialTypes =
          item.notRequiredMaterialTypes;
        item.requiredMaterialTypes.map((val) => {
          this.settingData.push({
            required: true,
            name: val,
          });
        });
        item.notRequiredMaterialTypes.map((val) => {
          this.settingData.push({
            required: false,
            name: val,
          });
        });
        // this.settingData =
      }
      this.isDrawerShow = true;
    },
    updateCollectReceipt() {
      this.collectReceiptForm.templates = [
        ...this.collectReceiptOne,
        ...this.collectReceiptTwo,
      ];
      let data = {
        settings: [
          {
            name: this.settingName,
            value: JSON.stringify(this.collectReceiptForm),
            isCollection: false,
            forceToSet: false,
          },
        ],
      };
      //console.log(this.collectReceipt, 999888);
      updateTransactionSettings(
        this.$store.getters.generateUpdateSettingsParams,
        data
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.getSettingData();
      });
    },
    toEdit(val) {
      if (val == "collectReceipt") {
        this.isCollectReceiptEdit = true;
      } else {
      }
    },
    // 获取基础字段
    getSettingData() {
      this.isCollectReceiptEdit = false;
      this.isLoading = true;
      let query = { type: "CollectReceipt" };

      getTransactionSettings(query)
        .then((res) => {
          this.isLoading = false;
          this.settingName = res.result[0].name;
          this.collectReceipt = res.result[0].value;
          this.collectReceiptForm = deepCopy(res.result[0].value);
          this.collectReceiptOne = this.collectReceipt.templates.slice(0, 8);
          this.collectReceiptTwo = this.collectReceipt.templates.slice(8, 16);
        })
        .catch((err) => {
          this.isLoading = false;
        });
      let paymentMaterialQuery = {
        type: "paymentMaterial",
      };
      getTransactionSettings(paymentMaterialQuery)
        .then((res) => {
          this.isLoading = false;
          this.paymentMaterial = res.result[0].value;
        })
        .catch((err) => {
          this.isLoading = false;
        });
      getTransactionSettings({ type: "CapitalParam" })
        .then((res) => {
          //console.log(res.result, 999);
          res.result.map((item) => {
            //console.log(item, 1111);
            if (item.name == "Deer.Transaction.Collection.CapitalType") {
              this.payTypeDic = item.value;
            }
          });
        })
        .catch((err) => {});
      getTransactionSettings({ type: "MaterialParam" })
        .then((res) => {
          //console.log(res.result, 999);
          this.paymentMaterialDic = res.result[0].value;
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#collectReceipt {
  // width: calc(100% - 280px);
  // padding-bottom: 20px;
  .setting-box {
    margin-bottom: 20px;
    padding-bottom: 20px;
    background: #fff;
    .title {
      @include flex(row, center);
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 15px;
      .button {
        cursor: pointer;
        font-size: 14px;
        color: $--color-primary;
      }
    }
    .tip,
    .paymentTip {
      padding: 0 25px;
      color: #444;
      .tip-tit {
        color: #666;
      }
      .tip-val {
        @include flex(row, center);
        .small-input {
          margin: 0 5px;
          width: 150px;
        }
      }
      .el-row {
        @include flex(row, center);
        margin-bottom: 15px;
      }
      .click-btn {
        cursor: pointer;
        color: $--color-primary;
      }

      .margin-bottom {
        margin-bottom: 0;
      }
    }
    .paymentTip {
      .el-row {
        margin-bottom: 0;
      }
    }
    .setting-val {
      @include flex(row, center);
      padding: 20px;
      ::v-deep .el-table {
        margin: 0 2px;
        margin-bottom: 30px;
        width: 49%;

        .el-table__header {
          th {
            background-color: #f2f2f2;
          }

          th {
            padding: 7px 0;
          }
        }

        td {
          padding: 7px 0;
        }

        .el-table__row {
          .cell {
            .setting-value {
              color: #000;
            }

            .setting-default {
              color: #888;
            }
          }
        }
      }
    }
  }
  .last {
    margin-bottom: 0px;
    padding-bottom: 0;
    .el-table {
      margin-bottom: 0 !important;
    }
  }

  ::v-deep .el-drawer {
    .drawer-title {
      width: 700px;
      border: 0;
    }
    .pay-type {
      padding-bottom: 20px;
      border-bottom: 1px dashed #387cef;
      width: 100%;
      .el-input {
        width: 200px;
      }
    }
    .add-setting {
      padding: 10px 0;
      border: 1px solid #dfdfdf;
      border-top: 0;
      width: 100%;
      text-align: center;
      color: $--color-primary;
      cursor: pointer;

      i {
        margin-right: 2px;
      }

      .required-item {
        margin-left: 4px;
        color: #f56c6c;
      }
    }
    .setting-form {
      padding-bottom: 20px;
      min-height: calc(100vh - 200px);
    }
    .dialog-footer {
      // position: absolute;
      // bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  ::v-deep .setting-dialog {
    .tips {
      color: #666;
    }
    img {
      margin-bottom: 20px;
    }
  }
}
</style>
